<template>
  <div class="mapbox">
    <!-- 第 1 页：交易明细滚动表格 -->
    <template v-if="activePage === 1">
      <button class="arrow" @click="activePage = 4">&#8592;</button>
      <div class="details">
        <div class="table-title">收购组织化</div>

        <div class="process-image">
          <img src="@/assets/images/purchase.png" alt="收购组织化图片" />
        </div>
      </div>
      <button class="arrow" @click="activePage = 2">&#8594;</button>
    </template>

    <!-- 第 2 页：收购组织化图片 -->
    <template v-if="activePage === 2">
      <button class="arrow" @click="activePage = 1">&#8592;</button>
      <div class="details">
        <div class="table-title">平台交易明细</div>
        <div v-if="loading" class="loading">
          <img src="@/assets/images/loading.gif" alt="加载中..." />
        </div>
        <dv-scroll-board :config="config" style="width: 100%; flex: 1; min-height: 0" />
      </div>

      <button class="arrow" @click="activePage = 3">&#8594;</button>
    </template>

    <!-- 第 3 页：收购点统计 -->
    <template v-if="activePage === 3">
      <button class="arrow" @click="activePage = 2">&#8592;</button>

      <div class="details">
        <div class="table-title">收购点业务统计</div>
        <div v-if="loading2" class="loading">
          <img src="@/assets/images/loading.gif" alt="加载中..." />
        </div>
        <dv-scroll-board
          :config="config2"
          @click="handleConfig2Click"
          style="width: 100%; flex: 1; min-height: 0; cursor: pointer" />
      </div>

      <button class="arrow" @click="activePage = 4">&#8594;</button>
    </template>

    <!-- 第 4 页：图表视图 -->
    <template v-if="activePage === 4">
      <button class="arrow" @click="activePage = 3">&#8592;</button>

      <div class="chart-area">
        <div class="header">统计分析</div>

        <!-- 图表 -->
        <div class="chart-box">
          <div ref="chart" class="chart"></div>
          <div ref="chart2" class="chart2"></div>
        </div>
      </div>

      <button class="arrow" @click="activePage = 1">&#8594;</button>
    </template>

    <!-- 收购点详情弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="720px"
      :modal="false"
      :close-on-click-modal="false"
      custom-class="merchant-detail-dialog">
      <div class="dialog-content">
        <div v-if="selectedMerchantInfo" class="merchant-summary">
          <div class="merchant-summary-title">商户概览</div>
          <div class="summary-grid">
            <div class="summary-card">
              <span class="summary-label">商户名称</span>
              <span class="summary-value">{{ selectedMerchantInfo.merchant_name || '—' }}</span>
            </div>
            <div class="summary-card">
              <span class="summary-label">交易量</span>
              <span class="summary-value">{{ selectedMerchantInfo.order_count || 0 }} 笔</span>
            </div>
            <div class="summary-card">
              <span class="summary-label">收购数量</span>
              <span class="summary-value">{{ selectedMerchantInfo.total_weight || 0 }} 公斤</span>
            </div>
            <div class="summary-card">
              <span class="summary-label">订单总金额</span>
              <span class="summary-value">
                {{ selectedMerchantInfo.total_order_amount || 0 }} 元
              </span>
            </div>
          </div>
        </div>

        <div v-if="dialogLoading" class="dialog-loading">
          <img src="@/assets/images/loading.gif" alt="加载中..." />
          <span>正在加载详情...</span>
        </div>

        <div
          v-else-if="currentMerchantDetail && currentMerchantDetail.length"
          class="detail-table-wrap">
          <div class="detail-table-title">最近订单明细</div>
          <dv-scroll-board :config="config3" style="width: 100%; height: 280px" />
        </div>

        <div v-else class="empty-state">暂无该收购点的订单详情</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getMerchantOrder } from '@/api/getData'
import { timestampToTime } from '@/utils/timestamp'
import * as echarts from 'echarts'
import { mapGetters } from 'vuex'

export default {
  name: 'BaseDetail',

  data() {
    return {
      loading: false,
      loading2: false,

      chart: null,
      chart2: null, // chart2 实例
      showChart: false,
      activePage: 1,
      timer: null,

      images: [
        require('@/assets/images/purchase_places/place1.jpg'),
        require('@/assets/images/purchase_places/place2.jpg'),
        require('@/assets/images/purchase_places/place3.jpg'),
        require('@/assets/images/purchase_places/place4.jpg')
        // require('@/assets/images/purchase_places/place5.jpg')
      ],

      // dateList: [], // 时间
      // buyAmount: [], // 总金额
      // buyNum: [], // 总数量
      // orderStatList: [], // 收购统计数据列表

      dialogVisible: false, // 收购详情弹窗
      dialogLoading: false,
      dialogTitle: '收购点详情',
      selectedMerchantInfo: null,
      currentMerchantDetail: null, // 单个收购详情数据

      //交易明细
      config: {
        header: ['序号', '订单编号', '商户', '供应商', '金额(元)', '交易时间'],
        data: [],
        rowNum: 8,
        headerHeight: 35,
        align: ['center', 'center', 'center'],
        oddRowBGC: 'rgba(0, 80, 120, 0.2)',
        evenRowBGC: 'rgba(0, 50, 80, 0.1)',
        columnWidth: [60, 190, 170]
      },

      //收购点统计数据
      config2: {
        header: ['序号', '商户名称', '交易量(笔)', '收购数量(公斤)', '订单总金额(元)'],
        data: [],
        rowNum: 8,
        headerHeight: 35,
        align: ['center', 'center', 'center'],
        oddRowBGC: 'rgba(0, 80, 120, 0.2)',
        evenRowBGC: 'rgba(0, 50, 80, 0.1)',
        columnWidth: [60, 220]
      },

      // 单个收购点详情
      config3: {
        header: ['序号', '订单编号', '订单数量(公斤)', '订单金额(元)', '交易时间'],
        data: [],
        rowNum: 4,
        headerHeight: 35,
        align: ['center', 'center', 'center'],
        oddRowBGC: 'rgba(0, 80, 120, 0.2)',
        evenRowBGC: 'rgba(0, 50, 80, 0.1)',
        columnWidth: [60, 220]
      }
    }
  },

  created() {
    // this.fetchData()
    // this.timer = setInterval(() => {
    //   this.fetchData()
    // }, 3 * 60 * 1000)
  },

  computed: {
    ...mapGetters('dashboard', ['buyPrice', 'orderList', 'orderStatList']),

    // 时间
    dateList() {
      return this.buyPrice.date_list || []
    },

    // 总金额
    buyAmount() {
      const buyAmount = this.buyPrice.buy_amount || []
      return buyAmount.map(v => +(v / 10000).toFixed(2))
    },

    // 总数量
    buyNum() {
      const buyNum = this.buyPrice.buy_num || []
      return buyNum.map(v => +(v / 2000).toFixed(2))
    }
  },

  watch: {
    activePage(newVal) {
      if (newVal === 4) {
        this.$nextTick(() => {
          this.initChart()
          this.initChart2()
        })
      }
    },

    dateList: {
      handler() {
        if (this.chart) {
          this.chart.setOption({
            xAxis: { data: this.dateList },
            series: [{ data: this.buyNum }]
          })
        }

        if (this.chart2) {
          this.chart2.setOption({
            xAxis: { data: this.dateList },
            series: [{ data: this.buyAmount }]
          })
        }
      },
      deep: true
    },

    orderList: {
      handler() {
        this.updateCharts()
      },
      deep: true,
      immediate: true
    },

    orderStatList: {
      handler() {
        this.updateCharts()
      },
      deep: true,
      immediate: true
    }
  },

  beforeDestroy() {
    if (this.chart) this.chart.dispose()
    if (this.chart2) this.chart2.dispose()
    clearInterval(this.timer)
  },

  methods: {
    timestampToTime,

    // 对商户名称进行处理
    hideMerchantName(name) {
      if (!name) return ''

      const length = name.length

      if (name.endsWith('公司')) {
        if (length <= 2) {
          return name
        }

        return name.slice(0, 2) + '*'.repeat(length - 4) + '公司'
      }

      return name.slice(0, 1) + '*'.repeat(length - 1)
    },

    updateCharts() {
      this.loading = true
      this.loading2 = true

      // 日期从近到远排序
      const tradeList = [...this.orderList].sort((a, b) => b.create_at - a.create_at)

      // 交易明细
      this.config = {
        ...this.config,
        data: tradeList.map((item, index) => {
          const orderSn = item.order_sn || ''
          const splitIndex = Math.ceil(orderSn.length / 2)
          const orderSnFirst = orderSn.slice(0, splitIndex)
          const orderSnSecond = orderSn.slice(splitIndex)

          return [
            String(index + 1),
            `${orderSnFirst}\n${orderSnSecond}`, // 分两行展示订单编号
            this.hideMerchantName(item.merchant_name),
            this.hideMerchantName(item.supply_name),
            item.order_amount,
            this.timestampToTime(item.create_at)
          ]
        })
      }

      this.loading = false

      // 各商户收购统计
      // console.log(this.orderStatList)
      this.config2 = {
        ...this.config2,
        data: this.orderStatList.map((item, index) => {
          return [
            String(index + 1),
            this.hideMerchantName(item.merchant_name),
            item.order_count,
            item.total_weight,
            item.total_order_amount
          ]
        })
      }

      this.loading2 = false

      // 统计图表
      if (this.chart) {
        this.chart.setOption({
          xAxis: { data: this.dateList },
          series: [{ data: this.buyNum }]
        })
      }
      if (this.chart2) {
        this.chart2.setOption({
          xAxis: { data: this.dateList },
          series: [{ data: this.buyAmount }]
        })
      }
    },

    // 点击单个收购点
    async handleConfig2Click({ rowIndex }) {
      const item = this.orderStatList[rowIndex]
      if (!item) return

      this.dialogVisible = true
      this.dialogLoading = true
      // this.dialogTitle = item.merchant_name || '收购点详情'
      this.selectedMerchantInfo = {
        merchant_name: this.hideMerchantName(item.merchant_name),
        order_count: item.order_count,
        total_weight: item.total_weight,
        total_order_amount: item.total_order_amount
      }
      this.currentMerchantDetail = []
      this.config3 = {
        ...this.config3,
        data: []
      }

      try {
        const res = await getMerchantOrder({ mid: item.mid })

        if (res.resultCode == 1) {
          const orderDetail = [...(res.resultInfo || [])].sort((a, b) => b.create_at - a.create_at)
          this.currentMerchantDetail = orderDetail

          this.config3 = {
            ...this.config3,
            data: orderDetail.map((detailItem, index) => {
              const orderSn = detailItem.order_sn || ''
              const splitIndex = Math.ceil(orderSn.length / 2)
              const orderSnFirst = orderSn.slice(0, splitIndex)
              const orderSnSecond = orderSn.slice(splitIndex)

              return [
                String(index + 1),
                `${orderSnFirst}\n${orderSnSecond}`,
                detailItem.total_weight,
                detailItem.order_amount,
                this.timestampToTime(detailItem.create_at)
              ]
            })
          }
        }
      } catch (error) {
        console.log(error)
        this.currentMerchantDetail = []
      } finally {
        this.dialogLoading = false
      }
    },

    // 收购总数量柱形图
    initChart() {
      // 确保 DOM 元素存在
      if (!this.$refs.chart) return

      this.chart = echarts.init(this.$refs.chart)

      window.addEventListener('resize', () => {
        if (this.chart) this.chart.resize()
      })

      const option = {
        backgroundColor: 'transparent',

        title: {
          text: '近15日收购数量',
          left: 'center',
          textStyle: {
            color: '#ffffff',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },

        grid: {
          left: '5%',
          right: '5%',
          bottom: '5%',
          top: '15%',
          containLabel: true
        },

        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,20,40,0.85)',
          borderColor: '#00cfff',
          borderWidth: 1,
          textStyle: { color: '#c0e8f0' },
          axisPointer: {
            type: 'cross',
            lineStyle: { color: '#00cfff44' }
          }
        },

        legend: {
          top: 8,
          right: 12,
          textStyle: { color: '#8fb8c8', fontSize: 12 },
          itemWidth: 14,
          itemHeight: 8,
          data: ['收购数量']
        },

        xAxis: {
          type: 'category',
          data: this.dateList,
          axisLine: {
            lineStyle: { color: '#1a4a6a' }
            // symbol: ['none', 'arrow'], // [起点, 终点] 箭头
            // symbolSize: [8, 12], // [宽, 高]
            // symbolOffset: [0, 10] // 箭头偏移量
          },
          axisTick: { show: false },
          axisLabel: { color: '#8fb8c8', fontSize: 12 },
          splitLine: { show: false }
        },

        yAxis: [
          {
            // 左轴：收购数量
            type: 'value',
            name: '数量(吨)',
            nameTextStyle: { color: '#8fb8c8', fontSize: 11 },
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: { color: '#8fb8c8', fontSize: 11 },
            splitLine: { lineStyle: { color: '#1a3a5a', type: 'dashed' } }
          }
        ],

        series: [
          {
            name: '收购数量',
            type: 'bar',
            yAxisIndex: 0,
            data: this.buyNum,
            barWidth: '35%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00cfff' },
                { offset: 1, color: '#0a4a6a' }
              ]),
              borderRadius: [4, 4, 0, 0]
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#40dfff' },
                  { offset: 1, color: '#0a4a6a' }
                ])
              }
            }
          }
        ]
      }

      this.chart.setOption(option)
    },

    // 收购总金额折线图
    initChart2() {
      if (!this.$refs.chart2) return

      this.chart2 = echarts.init(this.$refs.chart2)
      window.addEventListener('resize', () => {
        if (this.chart2) this.chart2.resize()
      })

      this.chart2.setOption({
        backgroundColor: 'transparent',
        title: {
          text: '近15日收购金额',
          left: 'center',
          textStyle: { color: '#ffffff', fontSize: 18, fontWeight: 'bold' }
        },
        grid: { left: '5%', right: '5%', bottom: '5%', top: '15%', containLabel: true },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,20,40,0.85)',
          borderColor: '#00cfff',
          borderWidth: 1,
          textStyle: { color: '#c0e8f0' },
          axisPointer: { type: 'cross', lineStyle: { color: '#00cfff44' } }
          // formatter(params) {
          //   return `${params[0].axisValue}<br/>${params[0].marker}收购均价：${params[0].value} 元/斤`
          // }
        },
        legend: {
          top: 8,
          right: 12,
          textStyle: { color: '#8fb8c8', fontSize: 12 },
          itemWidth: 14,
          itemHeight: 8,
          data: ['收购金额']
        },
        xAxis: {
          type: 'category',
          data: this.dateList,
          axisLine: { lineStyle: { color: '#1a4a6a' } },
          axisTick: { show: false },
          axisLabel: { color: '#8fb8c8', fontSize: 12 },
          splitLine: { show: false }
        },

        yAxis: {
          type: 'value',
          name: '金额(万元)',
          nameTextStyle: { color: '#8fb8c8', fontSize: 11 },
          nameGap: 8,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: '#8fb8c8', fontSize: 11, formatter: '{value}' },
          splitLine: { lineStyle: { color: '#1a3a5a', type: 'dashed' } }
        },
        series: [
          {
            name: '收购金额',
            type: 'line',
            data: this.buyAmount,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { color: '#f0a020', width: 2 },
            itemStyle: { color: '#f0a020', borderColor: '#fff', borderWidth: 1 },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#f0a02030' },
                { offset: 1, color: '#f0a02000' }
              ])
            }
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
.mapbox {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 16px;
  gap: 12px;
}

.header {
  color: #ffffff;
  font-size: 20px;
  text-align: center;
  padding-top: 18px;
  flex-shrink: 0;
  /* font-weight: 600; */
}

.scroll-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  height: 100%;
  gap: 8px;
  overflow: hidden;
}

.scroll-track {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 40px;
  /* overflow-y: auto;
  scrollbar-width: none; */
  width: 100%;
  height: 100%;
  padding: 10px 0 40px;
}

.scroll-track::-webkit-scrollbar {
  display: none;
}

/* 图片样式 */
.scroll-item {
  flex-shrink: 0;
  width: 47%;
  height: 45%;
  object-fit: fill;
  border-radius: 8px;
  /* border: 1px solid #1a6b8a; */
}

.loading {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 10, 20, 0.432);
}

.loading img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.process-image {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 80%;
    width: 95%;
  }
}

.arrow {
  flex-shrink: 0;
  align-self: center;
  background: rgba(0, 180, 220, 0.15);
  border: 1px solid #00cfff;
  color: #00cfff;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
}

.chart-area {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.chart-box {
  flex: 1; /* 撑满剩余空间 */
  min-height: 0; /* flex 子元素必须加，否则高度计算异常 */
  /* padding: 20px;  */
  box-sizing: border-box;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: center;
}

.chart {
  width: 50%;
  height: 70%;
}

.chart2 {
  width: 50%;
  height: 70%;
}

.details {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 18px 0;
  box-sizing: border-box;
}

.table-title {
  color: #ffffff;
  font-size: 20px;
  text-align: center;
  padding-bottom: 8px;
  flex-shrink: 0;
  /* opacity: 0.85; */
}

/* datav 表格样式覆盖 */
:deep(.dv-scroll-board .header) {
  background-color: rgba(0, 133, 183, 0.45) !important;
  border-radius: 6px;
  height: 40px;
}

:deep(.dv-scroll-board .header .header-item) {
  color: #baf5fd !important;
  font-size: 16px !important;
  text-align: center !important;
  line-height: 40px !important;
  height: 40px !important;
}

:deep(.dv-scroll-board .rows .ceil) {
  font-size: 14px !important;
  color: #7ee8f5 !important;
  text-align: center !important;
  white-space: pre-wrap !important;
  word-break: break-all !important;
  line-height: 1.5 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

:deep(.dv-scroll-board .rows) {
  will-change: transform;
}

/* :deep(.dv-scroll-board .rows .ceil) {
  font-size: 14px !important;
  color: #7ee8f5 !important;
  text-align: center !important;
  white-space: normal !important;
  word-break: break-all !important;
  line-height: 40px !important;
} */

:deep(.dv-scroll-board .rows .row-item) {
  border-bottom: 1px solid rgba(0, 180, 220, 0.08);
}

:deep(.merchant-detail-dialog) {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);
}

:deep(.merchant-detail-dialog .el-dialog__header) {
  background: linear-gradient(135deg, rgba(0, 40, 72, 0.98), rgba(0, 20, 43, 0.98));
  border-bottom: 1px solid rgba(0, 180, 220, 0.25);
  padding: 16px 20px;
}

:deep(.merchant-detail-dialog .el-dialog__title) {
  color: #baf5fd;
  font-size: 18px;
  font-weight: 600;
}

:deep(.merchant-detail-dialog .el-dialog__body) {
  background: rgba(0, 16, 34, 0.96);
  color: #e6faff;
  padding: 18px 20px 12px;
}

:deep(.merchant-detail-dialog .el-dialog__footer) {
  background: rgba(0, 16, 34, 0.96);
  border-top: 1px solid rgba(0, 180, 220, 0.2);
  padding: 12px 20px 16px;
}

:deep(.merchant-detail-dialog .el-button--primary) {
  background: linear-gradient(135deg, #00cfff, #0086bd);
  border: none;
}

.dialog-content {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.merchant-summary {
  padding: 12px 14px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(0, 180, 220, 0.16), rgba(0, 95, 140, 0.16));
  border: 1px solid rgba(0, 180, 220, 0.22);
}

.merchant-summary-title {
  color: #7ee8f5;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.summary-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.summary-label {
  font-size: 12px;
  color: #8fb8c8;
}

.summary-value {
  font-size: 14px;
  color: #f0fbff;
  font-weight: 600;
  word-break: break-all;
}

.dialog-loading,
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 120px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  color: #8fb8c8;
}

.dialog-loading img {
  width: 32px;
  height: 32px;
}

.detail-table-wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-table-title {
  color: #7ee8f5;
  font-size: 14px;
  font-weight: 600;
}

:deep(.v-modal) {
  background: none !important;
}
</style>
